import './index.css';

const AuthContainer = ({ children }) => {
    return (
        <div className="auth-container">
            {children}
        </div>
    )
}

export default AuthContainer;